import React from 'react';
import { contactInfo } from '../data/mock';

const OrganizationSchema = () => {
  const siteUrl = window.location.origin;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Maverxx Innovations",
    "url": siteUrl,
    "@id": `${siteUrl}/#organization`,
    "logo": `${siteUrl}/logo.png`,
    "description": "Precision 3D printing and industrial manufacturing solutions for engineers, startups, and industrial partners.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "F115, Samanway Westbreeze, Radiyat ba marg, Nr. Tithi heights, New Alkapuri, Gotri",
      "addressLocality": "Vadodara",
      "postalCode": "390021",
      "addressRegion": "Gujarat",
      "addressCountry": "India"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": `+91-${contactInfo.phone}`,
      "contactType": "customer service",
      "areaServed": "IN",
      "availableLanguage": ["English", "Hindi"]
    },
    "email": contactInfo.email,
    "sameAs": [
      `https://wa.me/${contactInfo.whatsapp}`
    ]
  };

  return (
    <script
      type="application/ld+json"
      data-testid="organization-schema-jsonld"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default OrganizationSchema;
